var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center mb-3 mb-md-4"},[_c('div',{staticClass:"col-auto mr-auto order-first"},[_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }